import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { Preferences } from '@capacitor/preferences';
import { appStorage } from '@/lib/appStorage';

/**
 * 🚀 Hook para gerenciar ciclo de vida do app
 * Otimiza performance quando app vai para background/foreground
 */
export const useAppLifecycle = () => {
  useEffect(() => {
    const handleAppStateChange = async (state: { isActive: boolean }) => {
      // Removido código de backup obsoleto
      // O sistema atual já possui mecanismos robustos de persistência
      // através do Supabase e AuthContext
    };

    App.addListener('appStateChange', handleAppStateChange);

    return () => {
      App.removeAllListeners();
    };
  }, []);
}; 